export interface MedicationData {
  name: string
  commonDosages: string[]
  category: string
  genericName?: string
  brandNames?: string[]
  commonInstructions?: string[]
}

export const medicationsDatabase: MedicationData[] = [
  // Diabetes
  {
    name: "Metformina",
    commonDosages: ["500mg", "850mg", "1000mg"],
    category: "Diabetes",
    genericName: "Metformin",
    brandNames: ["Glucophage", "Diabex"],
    commonInstructions: ["Tomar con alimentos", "Una vez al día", "Dos veces al día"]
  },
  {
    name: "Glibenclamida",
    commonDosages: ["5mg", "2.5mg"],
    category: "Diabetes",
    genericName: "Glyburide",
    brandNames: ["Daonil", "Euglucon"],
    commonInstructions: ["Antes del desayuno", "Con el primer alimento del día"]
  },
  {
    name: "Insulina",
    commonDosages: ["100 UI/ml", "40 UI/ml"],
    category: "Diabetes",
    genericName: "Insulin",
    brandNames: ["Lantus", "Humalog", "NovoRapid"],
    commonInstructions: ["Subcutánea", "Según indicación médica"]
  },

  // Hipertensión
  {
    name: "Losartán",
    commonDosages: ["50mg", "100mg"],
    category: "Hipertensión",
    genericName: "Losartan",
    brandNames: ["Cozaar", "Losaprex"],
    commonInstructions: ["Una vez al día", "Con o sin alimentos"]
  },
  {
    name: "Enalapril",
    commonDosages: ["5mg", "10mg", "20mg"],
    category: "Hipertensión",
    genericName: "Enalapril",
    brandNames: ["Renitec", "Vasotec"],
    commonInstructions: ["Una o dos veces al día", "Con o sin alimentos"]
  },
  {
    name: "Amlodipino",
    commonDosages: ["5mg", "10mg"],
    category: "Hipertensión",
    genericName: "Amlodipine",
    brandNames: ["Norvasc", "Amlovas"],
    commonInstructions: ["Una vez al día", "Preferiblemente por la mañana"]
  },
  {
    name: "Hidroclorotiazida",
    commonDosages: ["25mg", "50mg"],
    category: "Hipertensión",
    genericName: "Hydrochlorothiazide",
    brandNames: ["Microzide"],
    commonInstructions: ["Por la mañana", "Con o sin alimentos"]
  },

  // Colesterol
  {
    name: "Atorvastatina",
    commonDosages: ["10mg", "20mg", "40mg", "80mg"],
    category: "Colesterol",
    genericName: "Atorvastatin",
    brandNames: ["Lipitor", "Torvast"],
    commonInstructions: ["Por la noche", "Con o sin alimentos"]
  },
  {
    name: "Simvastatina",
    commonDosages: ["10mg", "20mg", "40mg"],
    category: "Colesterol",
    genericName: "Simvastatin",
    brandNames: ["Zocor", "Simvacor"],
    commonInstructions: ["Por la noche", "Con la cena"]
  },

  // Analgésicos
  {
    name: "Paracetamol",
    commonDosages: ["500mg", "1000mg"],
    category: "Analgésicos",
    genericName: "Acetaminophen",
    brandNames: ["Tylenol", "Panadol"],
    commonInstructions: ["Cada 6-8 horas", "Máximo 4g al día", "Con o sin alimentos"]
  },
  {
    name: "Ibuprofeno",
    commonDosages: ["400mg", "600mg", "800mg"],
    category: "Analgésicos",
    genericName: "Ibuprofen",
    brandNames: ["Advil", "Motrin"],
    commonInstructions: ["Con alimentos", "Cada 8 horas", "Después de comer"]
  },
  {
    name: "Diclofenaco",
    commonDosages: ["50mg", "75mg", "100mg"],
    category: "Analgésicos",
    genericName: "Diclofenac",
    brandNames: ["Voltaren", "Cataflam"],
    commonInstructions: ["Con alimentos", "Después de comer"]
  },
  {
    name: "Naproxeno",
    commonDosages: ["250mg", "500mg"],
    category: "Analgésicos",
    genericName: "Naproxen",
    brandNames: ["Aleve", "Flanax"],
    commonInstructions: ["Con alimentos", "Cada 12 horas"]
  },

  // Antibióticos
  {
    name: "Amoxicilina",
    commonDosages: ["500mg", "875mg", "250mg"],
    category: "Antibióticos",
    genericName: "Amoxicillin",
    brandNames: ["Amoxil", "Trimox"],
    commonInstructions: ["Cada 8 horas", "Completar tratamiento", "Con o sin alimentos"]
  },
  {
    name: "Azitromicina",
    commonDosages: ["250mg", "500mg"],
    category: "Antibióticos",
    genericName: "Azithromycin",
    brandNames: ["Zithromax", "Z-pack"],
    commonInstructions: ["Una vez al día", "Completar tratamiento"]
  },
  {
    name: "Ciprofloxacina",
    commonDosages: ["250mg", "500mg", "750mg"],
    category: "Antibióticos",
    genericName: "Ciprofloxacin",
    brandNames: ["Cipro"],
    commonInstructions: ["Cada 12 horas", "Con abundante agua", "Evitar lácteos"]
  },

  // Antiácidos
  {
    name: "Omeprazol",
    commonDosages: ["20mg", "40mg"],
    category: "Antiácidos",
    genericName: "Omeprazole",
    brandNames: ["Prilosec", "Losec"],
    commonInstructions: ["Antes del desayuno", "30 minutos antes de comer"]
  },
  {
    name: "Ranitidina",
    commonDosages: ["150mg", "300mg"],
    category: "Antiácidos",
    genericName: "Ranitidine",
    brandNames: ["Zantac"],
    commonInstructions: ["Con o sin alimentos", "Antes de acostarse"]
  },

  // Antihistamínicos
  {
    name: "Loratadina",
    commonDosages: ["10mg"],
    category: "Antihistamínicos",
    genericName: "Loratadine",
    brandNames: ["Claritin", "Alavert"],
    commonInstructions: ["Una vez al día", "Con o sin alimentos"]
  },
  {
    name: "Cetirizina",
    commonDosages: ["10mg"],
    category: "Antihistamínicos",
    genericName: "Cetirizine",
    brandNames: ["Zyrtec"],
    commonInstructions: ["Una vez al día", "Puede causar somnolencia"]
  },

  // Vitaminas
  {
    name: "Vitamina D3",
    commonDosages: ["1000 UI", "2000 UI", "5000 UI"],
    category: "Vitaminas",
    genericName: "Cholecalciferol",
    brandNames: ["D3"],
    commonInstructions: ["Una vez al día", "Con alimentos grasos"]
  },
  {
    name: "Vitamina B12",
    commonDosages: ["1000mcg", "2500mcg"],
    category: "Vitaminas",
    genericName: "Cyanocobalamin",
    brandNames: ["B12"],
    commonInstructions: ["Una vez al día", "Sublingual o con alimentos"]
  },
  {
    name: "Ácido Fólico",
    commonDosages: ["5mg", "400mcg"],
    category: "Vitaminas",
    genericName: "Folic Acid",
    brandNames: ["Folato"],
    commonInstructions: ["Una vez al día", "Con o sin alimentos"]
  },

  // Cardiovasculares
  {
    name: "Aspirina",
    commonDosages: ["100mg", "325mg"],
    category: "Cardiovasculares",
    genericName: "Aspirin",
    brandNames: ["Bayer", "Bufferin"],
    commonInstructions: ["Con alimentos", "Una vez al día", "Dosis baja cardioprotectora"]
  },
  {
    name: "Clopidogrel",
    commonDosages: ["75mg"],
    category: "Cardiovasculares",
    genericName: "Clopidogrel",
    brandNames: ["Plavix"],
    commonInstructions: ["Una vez al día", "Con o sin alimentos"]
  },

  // Antidepresivos
  {
    name: "Sertralina",
    commonDosages: ["25mg", "50mg", "100mg"],
    category: "Antidepresivos",
    genericName: "Sertraline",
    brandNames: ["Zoloft"],
    commonInstructions: ["Una vez al día", "Por la mañana", "Con o sin alimentos"]
  },
  {
    name: "Fluoxetina",
    commonDosages: ["10mg", "20mg", "40mg"],
    category: "Antidepresivos",
    genericName: "Fluoxetine",
    brandNames: ["Prozac"],
    commonInstructions: ["Por la mañana", "Con o sin alimentos"]
  },

  // Hormonales
  {
    name: "Levotiroxina",
    commonDosages: ["25mcg", "50mcg", "75mcg", "100mcg"],
    category: "Hormonales",
    genericName: "Levothyroxine",
    brandNames: ["Synthroid", "Levoxyl"],
    commonInstructions: ["En ayunas", "30 minutos antes del desayuno", "Una vez al día"]
  },

  // Anticoagulantes
  {
    name: "Warfarina",
    commonDosages: ["2mg", "5mg", "10mg"],
    category: "Anticoagulantes",
    genericName: "Warfarin",
    brandNames: ["Coumadin"],
    commonInstructions: ["Misma hora diaria", "Control INR regular", "Evitar cambios en dieta"]
  },

  // Broncodilatadores
  {
    name: "Salbutamol",
    commonDosages: ["100mcg/puff", "200mcg/puff"],
    category: "Broncodilatadores",
    genericName: "Albuterol",
    brandNames: ["Ventolin", "ProAir"],
    commonInstructions: ["Inhalado", "Según necesidad", "2 puffs cada 4-6 horas"]
  },
  {
    name: "Budesonida",
    commonDosages: ["200mcg/puff", "400mcg/puff"],
    category: "Broncodilatadores",
    genericName: "Budesonide",
    brandNames: ["Pulmicort", "Symbicort"],
    commonInstructions: ["Inhalado", "Dos veces al día", "Enjuagar boca después"]
  },

  // Anticonvulsivantes
  {
    name: "Fenitoína",
    commonDosages: ["100mg", "300mg"],
    category: "Anticonvulsivantes",
    genericName: "Phenytoin",
    brandNames: ["Dilantin"],
    commonInstructions: ["Con alimentos", "Mismo horario diario", "No suspender abruptamente"]
  },
  {
    name: "Carbamazepina",
    commonDosages: ["200mg", "400mg"],
    category: "Anticonvulsivantes",
    genericName: "Carbamazepine",
    brandNames: ["Tegretol"],
    commonInstructions: ["Con alimentos", "Aumentar dosis gradualmente"]
  },
  {
    name: "Ácido Valproico",
    commonDosages: ["250mg", "500mg"],
    category: "Anticonvulsivantes",
    genericName: "Valproic Acid",
    brandNames: ["Depakote", "Epilim"],
    commonInstructions: ["Con alimentos", "Control de función hepática"]
  },

  // Antifúngicos
  {
    name: "Fluconazol",
    commonDosages: ["150mg", "200mg"],
    category: "Antifúngicos",
    genericName: "Fluconazole",
    brandNames: ["Diflucan"],
    commonInstructions: ["Una vez al día", "Con o sin alimentos", "Completar tratamiento"]
  },
  {
    name: "Clotrimazol",
    commonDosages: ["1% crema", "10mg"],
    category: "Antifúngicos",
    genericName: "Clotrimazole",
    brandNames: ["Lotrimin", "Canesten"],
    commonInstructions: ["Aplicar 2-3 veces al día", "Área limpia y seca"]
  },

  // Corticosteroides
  {
    name: "Prednisona",
    commonDosages: ["5mg", "10mg", "20mg"],
    category: "Corticosteroides",
    genericName: "Prednisone",
    brandNames: ["Deltasone"],
    commonInstructions: ["Con alimentos", "Por la mañana", "Reducir gradualmente"]
  },
  {
    name: "Hidrocortisona",
    commonDosages: ["1% crema", "2.5% crema"],
    category: "Corticosteroides",
    genericName: "Hydrocortisone",
    brandNames: ["Cortaid"],
    commonInstructions: ["Aplicar capa fina", "2-3 veces al día", "No usar en cara prolongadamente"]
  },

  // Relajantes musculares
  {
    name: "Ciclobenzaprina",
    commonDosages: ["5mg", "10mg"],
    category: "Relajantes musculares",
    genericName: "Cyclobenzaprine",
    brandNames: ["Flexeril"],
    commonInstructions: ["Con o sin alimentos", "Puede causar somnolencia", "No conducir"]
  },
  {
    name: "Carisoprodol",
    commonDosages: ["350mg"],
    category: "Relajantes musculares",
    genericName: "Carisoprodol",
    brandNames: ["Soma"],
    commonInstructions: ["Con alimentos", "3-4 veces al día", "Uso a corto plazo"]
  },

  // Diuréticos
  {
    name: "Furosemida",
    commonDosages: ["20mg", "40mg"],
    category: "Diuréticos",
    genericName: "Furosemide",
    brandNames: ["Lasix"],
    commonInstructions: ["Por la mañana", "Con o sin alimentos", "Monitorear electrolitos"]
  },
  {
    name: "Espironolactona",
    commonDosages: ["25mg", "50mg"],
    category: "Diuréticos",
    genericName: "Spironolactone",
    brandNames: ["Aldactone"],
    commonInstructions: ["Con alimentos", "Una vez al día", "Monitorear potasio"]
  },

  // Antivirales
  {
    name: "Aciclovir",
    commonDosages: ["200mg", "400mg", "800mg"],
    category: "Antivirales",
    genericName: "Acyclovir",
    brandNames: ["Zovirax"],
    commonInstructions: ["Con abundante agua", "5 veces al día", "Completar tratamiento"]
  },
  {
    name: "Oseltamivir",
    commonDosages: ["75mg"],
    category: "Antivirales",
    genericName: "Oseltamivir",
    brandNames: ["Tamiflu"],
    commonInstructions: ["Con alimentos", "Dos veces al día", "Iniciar dentro 48h"]
  },

  // Antiespasmódicos
  {
    name: "Hioscina",
    commonDosages: ["10mg", "20mg"],
    category: "Antiespasmódicos",
    genericName: "Hyoscine",
    brandNames: ["Buscopan"],
    commonInstructions: ["Antes de comidas", "Según necesidad", "Para cólicos"]
  },
  {
    name: "Mebeverina",
    commonDosages: ["135mg"],
    category: "Antiespasmódicos",
    genericName: "Mebeverine",
    brandNames: ["Colofac"],
    commonInstructions: ["Antes de comidas", "Tres veces al día"]
  },

  // Medicina tropical y antiparasitarios
  {
    name: "Albendazol",
    commonDosages: ["400mg"],
    category: "Antiparasitarios",
    genericName: "Albendazole",
    brandNames: ["Zentel"],
    commonInstructions: ["Con alimentos", "Dosis única", "Repetir según indicación"]
  },
  {
    name: "Metronidazol",
    commonDosages: ["250mg", "500mg"],
    category: "Antiparasitarios",
    genericName: "Metronidazole",
    brandNames: ["Flagyl"],
    commonInstructions: ["Con alimentos", "Evitar alcohol", "Completar tratamiento"]
  },
  {
    name: "Ivermectina",
    commonDosages: ["3mg", "6mg"],
    category: "Antiparasitarios",
    genericName: "Ivermectin",
    brandNames: ["Stromectol"],
    commonInstructions: ["Con estómago vacío", "Dosis única", "Según peso corporal"]
  },

  // Suplementos minerales
  {
    name: "Hierro",
    commonDosages: ["65mg", "325mg"],
    category: "Suplementos",
    genericName: "Iron",
    brandNames: ["Feosol", "Ferro-Gradumet"],
    commonInstructions: ["Con estómago vacío", "Con vitamina C", "Puede causar estreñimiento"]
  },
  {
    name: "Calcio",
    commonDosages: ["500mg", "1000mg"],
    category: "Suplementos",
    genericName: "Calcium",
    brandNames: ["Os-Cal", "Caltrate"],
    commonInstructions: ["Con alimentos", "Dividir dosis", "Con vitamina D"]
  },
  {
    name: "Magnesio",
    commonDosages: ["200mg", "400mg"],
    category: "Suplementos",
    genericName: "Magnesium",
    brandNames: ["Mag-Ox"],
    commonInstructions: ["Con alimentos", "Puede causar diarrea en dosis altas"]
  },
  {
    name: "Zinc",
    commonDosages: ["15mg", "30mg"],
    category: "Suplementos",
    genericName: "Zinc",
    brandNames: ["Zincate"],
    commonInstructions: ["Con alimentos", "Para inmunidad", "No exceder dosis"]
  },

  // Medicamentos oftálmicos
  {
    name: "Timolol",
    commonDosages: ["0.25%", "0.5%"],
    category: "Oftálmicos",
    genericName: "Timolol",
    brandNames: ["Timoptic"],
    commonInstructions: ["1-2 gotas", "Dos veces al día", "Para glaucoma"]
  },
  {
    name: "Latanoprost",
    commonDosages: ["0.005%"],
    category: "Oftálmicos",
    genericName: "Latanoprost",
    brandNames: ["Xalatan"],
    commonInstructions: ["1 gota por la noche", "Para glaucoma", "Refrigerar"]
  },

  // Medicina geriátrica
  {
    name: "Donepezilo",
    commonDosages: ["5mg", "10mg"],
    category: "Geriátricos",
    genericName: "Donepezil",
    brandNames: ["Aricept"],
    commonInstructions: ["Por la noche", "Para Alzheimer", "Con o sin alimentos"]
  },
  {
    name: "Memantina",
    commonDosages: ["5mg", "10mg"],
    category: "Geriátricos",
    genericName: "Memantine",
    brandNames: ["Namenda"],
    commonInstructions: ["Con o sin alimentos", "Para demencia moderada", "Aumentar gradualmente"]
  },

  // Medicamentos dermatológicos
  {
    name: "Tretinoína",
    commonDosages: ["0.025%", "0.05%"],
    category: "Dermatológicos",
    genericName: "Tretinoin",
    brandNames: ["Retin-A"],
    commonInstructions: ["Aplicar por la noche", "Usar protector solar", "Puede irritar inicialmente"]
  },
  {
    name: "Adapaleno",
    commonDosages: ["0.1%"],
    category: "Dermatológicos",
    genericName: "Adapalene",
    brandNames: ["Differin"],
    commonInstructions: ["Una vez al día por la noche", "Para acné", "Área limpia y seca"]
  },

  // Medicamentos urológicos
  {
    name: "Tamsulosina",
    commonDosages: ["0.4mg"],
    category: "Urológicos",
    genericName: "Tamsulosin",
    brandNames: ["Flomax"],
    commonInstructions: ["30 minutos después de comer", "Mismo horario diario", "Para próstata"]
  },
  {
    name: "Finasterida",
    commonDosages: ["1mg", "5mg"],
    category: "Urológicos",
    genericName: "Finasteride",
    brandNames: ["Proscar", "Propecia"],
    commonInstructions: ["Una vez al día", "Con o sin alimentos", "Para próstata/calvicie"]
  },

  // Medicamentos endocrinológicos adicionales
  {
    name: "Sitagliptina",
    commonDosages: ["50mg", "100mg"],
    category: "Diabetes",
    genericName: "Sitagliptin",
    brandNames: ["Januvia"],
    commonInstructions: ["Una vez al día", "Con o sin alimentos", "Para diabetes tipo 2"]
  },
  {
    name: "Empagliflozina",
    commonDosages: ["10mg", "25mg"],
    category: "Diabetes",
    genericName: "Empagliflozin",
    brandNames: ["Jardiance"],
    commonInstructions: ["Por la mañana", "Con o sin alimentos", "Beber abundante agua"]
  },

  // Medicamentos gastrointestinales adicionales
  {
    name: "Lansoprazol",
    commonDosages: ["15mg", "30mg"],
    category: "Antiácidos",
    genericName: "Lansoprazole",
    brandNames: ["Prevacid"],
    commonInstructions: ["Antes del desayuno", "Tragar entero", "No masticar"]
  },
  {
    name: "Pantoprazol",
    commonDosages: ["20mg", "40mg"],
    category: "Antiácidos",
    genericName: "Pantoprazole",
    brandNames: ["Protonix"],
    commonInstructions: ["30 minutos antes de comer", "Una vez al día"]
  },
  {
    name: "Domperidona",
    commonDosages: ["10mg"],
    category: "Gastrointestinales",
    genericName: "Domperidone",
    brandNames: ["Motilium"],
    commonInstructions: ["Antes de comidas", "Tres veces al día", "Para náuseas"]
  },

  // Medicamentos cardiovasculares adicionales
  {
    name: "Bisoprolol",
    commonDosages: ["2.5mg", "5mg", "10mg"],
    category: "Hipertensión",
    genericName: "Bisoprolol",
    brandNames: ["Zebeta"],
    commonInstructions: ["Una vez al día", "Por la mañana", "Con o sin alimentos"]
  },
  {
    name: "Valsartán",
    commonDosages: ["80mg", "160mg"],
    category: "Hipertensión",
    genericName: "Valsartan",
    brandNames: ["Diovan"],
    commonInstructions: ["Una vez al día", "Con o sin alimentos"]
  },
  {
    name: "Diltiazem",
    commonDosages: ["120mg", "180mg"],
    category: "Hipertensión",
    genericName: "Diltiazem",
    brandNames: ["Cardizem"],
    commonInstructions: ["Una vez al día", "No masticar", "Liberación prolongada"]
  },

  // Medicina pediátrica
  {
    name: "Amoxicilina Suspensión",
    commonDosages: ["125mg/5ml", "250mg/5ml"],
    category: "Pediátricos",
    genericName: "Amoxicillin",
    brandNames: ["Amoxil"],
    commonInstructions: ["Cada 8 horas", "Agitar antes de usar", "Refrigerar"]
  },
  {
    name: "Acetaminofén Jarabe",
    commonDosages: ["160mg/5ml"],
    category: "Pediátricos",
    genericName: "Acetaminophen",
    brandNames: ["Tylenol"],
    commonInstructions: ["Según peso", "Cada 4-6 horas", "Máximo 5 dosis/día"]
  },

  // Medicamentos psiquiátricos adicionales
  {
    name: "Escitalopram",
    commonDosages: ["5mg", "10mg", "20mg"],
    category: "Antidepresivos",
    genericName: "Escitalopram",
    brandNames: ["Lexapro"],
    commonInstructions: ["Una vez al día", "Por la mañana", "Con o sin alimentos"]
  },
  {
    name: "Venlafaxina",
    commonDosages: ["37.5mg", "75mg", "150mg"],
    category: "Antidepresivos",
    genericName: "Venlafaxine",
    brandNames: ["Effexor"],
    commonInstructions: ["Con alimentos", "Mismo horario diario", "No suspender abruptamente"]
  },
  {
    name: "Quetiapina",
    commonDosages: ["25mg", "50mg", "100mg"],
    category: "Antipsicóticos",
    genericName: "Quetiapine",
    brandNames: ["Seroquel"],
    commonInstructions: ["Por la noche", "Con o sin alimentos", "Puede causar somnolencia"]
  },
  {
    name: "Lorazepam",
    commonDosages: ["0.5mg", "1mg", "2mg"],
    category: "Ansiolíticos",
    genericName: "Lorazepam",
    brandNames: ["Ativan"],
    commonInstructions: ["Según necesidad", "Puede causar dependencia", "No conducir"]
  },

  // Medicina reproductiva
  {
    name: "Anticonceptivos Orales",
    commonDosages: ["21 tabletas", "28 tabletas"],
    category: "Hormonales",
    genericName: "Oral Contraceptives",
    brandNames: ["Yasmin", "Diane"],
    commonInstructions: ["Misma hora diaria", "Con o sin alimentos", "No omitir dosis"]
  },
  {
    name: "Clomifeno",
    commonDosages: ["50mg"],
    category: "Hormonales",
    genericName: "Clomiphene",
    brandNames: ["Clomid"],
    commonInstructions: ["Día 3-7 del ciclo", "Una vez al día", "Monitoreo médico"]
  },

  // Medicamentos específicos latinoamericanos
  {
    name: "Minuslip",
    commonDosages: ["25mg", "50mg"],
    category: "Hipertensión",
    genericName: "Captopril",
    brandNames: ["Minuslip", "Capoten"],
    commonInstructions: ["Con estómago vacío", "1 hora antes de comidas", "Dos o tres veces al día"]
  },
  {
    name: "Captopril",
    commonDosages: ["25mg", "50mg"],
    category: "Hipertensión",
    genericName: "Captopril",
    brandNames: ["Minuslip", "Capoten", "Acepril"],
    commonInstructions: ["Con estómago vacío", "1 hora antes de comidas", "Dos o tres veces al día"]
  },
  {
    name: "Dolex",
    commonDosages: ["500mg"],
    category: "Analgésicos",
    genericName: "Acetaminophen",
    brandNames: ["Dolex", "Tylenol"],
    commonInstructions: ["Cada 6-8 horas", "Con o sin alimentos", "Máximo 4g al día"]
  },
  {
    name: "Advil",
    commonDosages: ["200mg", "400mg"],
    category: "Analgésicos",
    genericName: "Ibuprofen",
    brandNames: ["Advil", "Motrin"],
    commonInstructions: ["Con alimentos", "Cada 8 horas", "Después de comer"]
  },
  {
    name: "Buscapina",
    commonDosages: ["10mg", "20mg"],
    category: "Antiespasmódicos",
    genericName: "Hyoscine",
    brandNames: ["Buscapina", "Buscopan"],
    commonInstructions: ["Antes de comidas", "Según necesidad", "Para cólicos abdominales"]
  },
  {
    name: "Mylanta",
    commonDosages: ["400mg", "800mg"],
    category: "Antiácidos",
    genericName: "Aluminum hydroxide + Magnesium hydroxide",
    brandNames: ["Mylanta", "Maalox"],
    commonInstructions: ["Entre comidas", "Al acostarse", "Masticar bien"]
  },
  {
    name: "Pepto Bismol",
    commonDosages: ["262mg"],
    category: "Gastrointestinales",
    genericName: "Bismuth subsalicylate",
    brandNames: ["Pepto Bismol"],
    commonInstructions: ["Cada 30-60 minutos", "Máximo 8 dosis al día", "Para diarrea y malestar estomacal"]
  },
  {
    name: "Gravol",
    commonDosages: ["50mg"],
    category: "Antihistamínicos",
    genericName: "Dimenhydrinate",
    brandNames: ["Gravol", "Dramamine"],
    commonInstructions: ["30 minutos antes del viaje", "Cada 4-6 horas", "Puede causar somnolencia"]
  },
  {
    name: "Benadryl",
    commonDosages: ["25mg", "50mg"],
    category: "Antihistamínicos",
    genericName: "Diphenhydramine",
    brandNames: ["Benadryl"],
    commonInstructions: ["Cada 4-6 horas", "Puede causar somnolencia", "Con o sin alimentos"]
  },
  {
    name: "Voltaren",
    commonDosages: ["50mg", "75mg", "100mg"],
    category: "Analgésicos",
    genericName: "Diclofenac",
    brandNames: ["Voltaren", "Cataflam"],
    commonInstructions: ["Con alimentos", "Después de comer", "Para dolor e inflamación"]
  },
  {
    name: "Cataflam",
    commonDosages: ["50mg"],
    category: "Analgésicos",
    genericName: "Diclofenac potassium",
    brandNames: ["Cataflam", "Voltaren"],
    commonInstructions: ["Con alimentos", "Acción rápida", "Para dolor agudo"]
  },
  {
    name: "Aspirina",
    commonDosages: ["100mg", "325mg", "500mg"],
    category: "Analgésicos",
    genericName: "Aspirin",
    brandNames: ["Aspirina", "Bayer", "Mejoral"],
    commonInstructions: ["Con alimentos", "Una vez al día para cardioprotección", "Cada 4-6 horas para dolor"]
  },
  {
    name: "Mejoral",
    commonDosages: ["500mg"],
    category: "Analgésicos",
    genericName: "Aspirin",
    brandNames: ["Mejoral", "Aspirina"],
    commonInstructions: ["Con alimentos", "Cada 4-6 horas", "Para dolor de cabeza"]
  },
  {
    name: "Redoxon",
    commonDosages: ["1000mg"],
    category: "Vitaminas",
    genericName: "Vitamin C",
    brandNames: ["Redoxon", "Cevalin"],
    commonInstructions: ["Una vez al día", "Con alimentos", "Disolver en agua"]
  },
  {
    name: "Supradyn",
    commonDosages: ["1 tableta"],
    category: "Vitaminas",
    genericName: "Multivitamin",
    brandNames: ["Supradyn", "Centrum"],
    commonInstructions: ["Una vez al día", "Con el desayuno", "Multivitamínico completo"]
  },
  {
    name: "Berocca",
    commonDosages: ["1 tableta efervescente"],
    category: "Vitaminas",
    genericName: "B-Complex + Vitamin C",
    brandNames: ["Berocca"],
    commonInstructions: ["Una vez al día", "Disolver en agua", "Por la mañana con el desayuno"]
  },
  {
    name: "Centrum",
    commonDosages: ["1 tableta"],
    category: "Vitaminas",
    genericName: "Multivitamin",
    brandNames: ["Centrum", "Supradyn"],
    commonInstructions: ["Una vez al día", "Con alimentos", "Multivitamínico diario"]
  },
  {
    name: "Glucophage",
    commonDosages: ["500mg", "850mg", "1000mg"],
    category: "Diabetes",
    genericName: "Metformin",
    brandNames: ["Glucophage", "Diabex"],
    commonInstructions: ["Con alimentos", "Para reducir efectos gastrointestinales", "Una o dos veces al día"]
  },
  {
    name: "Diabex",
    commonDosages: ["500mg", "850mg"],
    category: "Diabetes",
    genericName: "Metformin",
    brandNames: ["Diabex", "Glucophage"],
    commonInstructions: ["Con alimentos", "Comenzar con dosis baja", "Aumentar gradualmente"]
  },
  {
    name: "Lantus",
    commonDosages: ["100 UI/ml"],
    category: "Diabetes",
    genericName: "Insulin glargine",
    brandNames: ["Lantus", "Toujeo"],
    commonInstructions: ["Subcutánea", "Misma hora diaria", "Insulina de acción prolongada"]
  },
  {
    name: "Humalog",
    commonDosages: ["100 UI/ml"],
    category: "Diabetes",
    genericName: "Insulin lispro",
    brandNames: ["Humalog"],
    commonInstructions: ["Antes de comidas", "Acción rápida", "Subcutánea"]
  },
  {
    name: "NovoRapid",
    commonDosages: ["100 UI/ml"],
    category: "Diabetes",
    genericName: "Insulin aspart",
    brandNames: ["NovoRapid"],
    commonInstructions: ["Antes de comidas", "Acción rápida", "0-10 minutos antes de comer"]
  },
  {
    name: "Norvasc",
    commonDosages: ["5mg", "10mg"],
    category: "Hipertensión",
    genericName: "Amlodipine",
    brandNames: ["Norvasc", "Amlovas"],
    commonInstructions: ["Una vez al día", "Mismo horario", "Con o sin alimentos"]
  },
  {
    name: "Cozaar",
    commonDosages: ["50mg", "100mg"],
    category: "Hipertensión",
    genericName: "Losartan",
    brandNames: ["Cozaar", "Losaprex"],
    commonInstructions: ["Una vez al día", "Con o sin alimentos", "Preferiblemente por la mañana"]
  },
  {
    name: "Renitec",
    commonDosages: ["5mg", "10mg", "20mg"],
    category: "Hipertensión",
    genericName: "Enalapril",
    brandNames: ["Renitec", "Vasotec"],
    commonInstructions: ["Una o dos veces al día", "Con o sin alimentos", "Monitorear función renal"]
  },
  {
    name: "Lipitor",
    commonDosages: ["10mg", "20mg", "40mg", "80mg"],
    category: "Colesterol",
    genericName: "Atorvastatin",
    brandNames: ["Lipitor", "Torvast"],
    commonInstructions: ["Por la noche", "Con o sin alimentos", "Control de lípidos"]
  },
  {
    name: "Zocor",
    commonDosages: ["10mg", "20mg", "40mg"],
    category: "Colesterol",
    genericName: "Simvastatin",
    brandNames: ["Zocor", "Simvacor"],
    commonInstructions: ["Por la noche", "Con la cena", "Evitar jugo de toronja"]
  },
  {
    name: "Nexium",
    commonDosages: ["20mg", "40mg"],
    category: "Antiácidos",
    genericName: "Esomeprazole",
    brandNames: ["Nexium"],
    commonInstructions: ["Antes del desayuno", "Tragar entero", "No masticar"]
  },
  {
    name: "Prilosec",
    commonDosages: ["20mg", "40mg"],
    category: "Antiácidos",
    genericName: "Omeprazole",
    brandNames: ["Prilosec", "Losec"],
    commonInstructions: ["Antes del desayuno", "30 minutos antes de comer", "Tragar entero"]
  },
  {
    name: "Zantac",
    commonDosages: ["150mg", "300mg"],
    category: "Antiácidos",
    genericName: "Ranitidine",
    brandNames: ["Zantac"],
    commonInstructions: ["Con o sin alimentos", "Antes de acostarse", "Para acidez nocturna"]
  },
  {
    name: "Claritin",
    commonDosages: ["10mg"],
    category: "Antihistamínicos",
    genericName: "Loratadine",
    brandNames: ["Claritin", "Alavert"],
    commonInstructions: ["Una vez al día", "No causa somnolencia", "Para alergias estacionales"]
  },
  {
    name: "Zyrtec",
    commonDosages: ["10mg"],
    category: "Antihistamínicos",
    genericName: "Cetirizine",
    brandNames: ["Zyrtec"],
    commonInstructions: ["Una vez al día", "Puede causar somnolencia leve", "Para alergias"]
  },
  {
    name: "Ventolin",
    commonDosages: ["100mcg/puff"],
    category: "Broncodilatadores",
    genericName: "Salbutamol",
    brandNames: ["Ventolin", "ProAir"],
    commonInstructions: ["Inhalado", "Según necesidad", "Para crisis asmática"]
  },
  {
    name: "Pulmicort",
    commonDosages: ["200mcg/puff"],
    category: "Broncodilatadores",
    genericName: "Budesonide",
    brandNames: ["Pulmicort"],
    commonInstructions: ["Inhalado", "Dos veces al día", "Enjuagar boca después"]
  },
  {
    name: "Symbicort",
    commonDosages: ["160/4.5mcg", "320/9mcg"],
    category: "Broncodilatadores",
    genericName: "Budesonide/Formoterol",
    brandNames: ["Symbicort"],
    commonInstructions: ["Inhalado", "Dos veces al día", "Combinación para asma"]
  },
  {
    name: "Prozac",
    commonDosages: ["10mg", "20mg", "40mg"],
    category: "Antidepresivos",
    genericName: "Fluoxetine",
    brandNames: ["Prozac"],
    commonInstructions: ["Por la mañana", "Con o sin alimentos", "Puede tomar semanas hacer efecto"]
  },
  {
    name: "Zoloft",
    commonDosages: ["25mg", "50mg", "100mg"],
    category: "Antidepresivos",
    genericName: "Sertraline",
    brandNames: ["Zoloft"],
    commonInstructions: ["Una vez al día", "Por la mañana o noche", "Con o sin alimentos"]
  },
  {
    name: "Lexapro",
    commonDosages: ["5mg", "10mg", "20mg"],
    category: "Antidepresivos",
    genericName: "Escitalopram",
    brandNames: ["Lexapro"],
    commonInstructions: ["Una vez al día", "Por la mañana", "Para depresión y ansiedad"]
  },
  {
    name: "Synthroid",
    commonDosages: ["25mcg", "50mcg", "75mcg", "100mcg", "125mcg"],
    category: "Hormonales",
    genericName: "Levothyroxine",
    brandNames: ["Synthroid", "Levoxyl"],
    commonInstructions: ["En ayunas", "30-60 minutos antes del desayuno", "Misma hora diaria"]
  },
  {
    name: "Coumadin",
    commonDosages: ["2mg", "5mg", "10mg"],
    category: "Anticoagulantes",
    genericName: "Warfarin",
    brandNames: ["Coumadin"],
    commonInstructions: ["Misma hora diaria", "Control INR frecuente", "Dieta consistente en vitamina K"]
  },
  {
    name: "Plavix",
    commonDosages: ["75mg"],
    category: "Cardiovasculares",
    genericName: "Clopidogrel",
    brandNames: ["Plavix"],
    commonInstructions: ["Una vez al día", "Con o sin alimentos", "Antiagregante plaquetario"]
  },
  {
    name: "Lasix",
    commonDosages: ["20mg", "40mg"],
    category: "Diuréticos",
    genericName: "Furosemide",
    brandNames: ["Lasix"],
    commonInstructions: ["Por la mañana", "Monitorear electrolitos", "Para retención de líquidos"]
  }
]

export const getMedicationSuggestions = (query: string): MedicationData[] => {
  if (!query || query.length < 1) return []
  
  const lowerQuery = query.toLowerCase()
  
  return medicationsDatabase.filter(med => 
    med.name.toLowerCase().includes(lowerQuery) ||
    med.genericName?.toLowerCase().includes(lowerQuery) ||
    med.brandNames?.some(brand => brand.toLowerCase().includes(lowerQuery))
  ).slice(0, 10) // Limit to 10 suggestions
}

export const getMedicationByName = (name: string): MedicationData | undefined => {
  return medicationsDatabase.find(med => 
    med.name.toLowerCase() === name.toLowerCase() ||
    med.genericName?.toLowerCase() === name.toLowerCase() ||
    med.brandNames?.some(brand => brand.toLowerCase() === name.toLowerCase())
  )
}

export const getMedicationsByCategory = (category: string): MedicationData[] => {
  return medicationsDatabase.filter(med => 
    med.category.toLowerCase() === category.toLowerCase()
  )
}

export const getAllCategories = (): string[] => {
  const categories = new Set(medicationsDatabase.map(med => med.category))
  return Array.from(categories).sort()
}